export const qs = <T extends Element>(selector: string, ctx: ParentNode = document) => ctx.querySelector<T>(selector);

export const getHeaderSection = (scope: ParentNode = document) => qs<HTMLElement>(".js-collection-header", scope);

export const getGridSection = (scope: ParentNode = document) => qs<HTMLElement>(".js-collection-section", scope);

export const parseSectionHtml = (html: string, selector: string) => {
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.querySelector<HTMLElement>(selector);
};

export const parseSectionDocument = (html: string) => new DOMParser().parseFromString(html, "text/html");

export const replaceNode = (current: Element | null, next: Element | null) => {
  if (current && next) {
    current.replaceWith(document.importNode(next, true));
    return;
  }
  if (current && !next) current.remove();
};

export const getGridSectionId = (scope: ParentNode = document) => getGridSection(scope)?.dataset.sectionId ?? null;

export const getHeaderSectionId = (scope: ParentNode = document) => getHeaderSection(scope)?.dataset.sectionId ?? null;

export const fetchSectionHtml = async (url: string) => {
  const response = await fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } });
  if (!response.ok) return null;
  return response.text();
};
